import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiConfig } from '../Config/api.config';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http: HttpClient) {}

 getRegistrationLink(userNumber: string): Observable<any> {
     const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey
    });
    return this.http.get(
      `${ApiConfig.baseUrl}/auth/request-registration`,
      {
        headers,
        params: {
          userNumber
        }
      }
    );
  }
  getSecurityQuestions(userId: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey
    });
    return this.http.get(
      `${ApiConfig.baseUrl}/auth/security-questions`,
      {
        headers,
        params: {
          userId
        }
      }
    );
  }
  postSecurityAnswers(userId: string, questions: any[]): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey
    });
    const request = {
      userId,
      questions
    };
    return this.http.post(
      `${ApiConfig.baseUrl}/auth/security-answers`,
      request,
      {
        headers
      }
    );
  }
  getSetAuthorizationStatus(userId: string): Observable<any> {
     const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey
    });
    return this.http.get(
      `${ApiConfig.baseUrl}/auth/set-authorization-Status`,
      {
        headers,
        params: {
          userId
        }
      }
    );
  }
  postAuthorizationPin(userId: string, pin: string, requestType: string): Observable<any> {
     const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey
    });
    const request = {
      userId,
      pin,
      requestType
    };
    return this.http.post(
      `${ApiConfig.baseUrl}/auth/authorization-pin`,
      request,
      {
        headers
      }
    );
  }
  getLoginKey(userId: string): Observable<any> {
     const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey
    });
    return this.http.get(
      `${ApiConfig.baseUrl}/auth/login-key`,
      {
        headers,
        params: {
          userId
        }
      }
    );
  }
  postLogin(loginKey: string, userId: string, pin: string): Observable<any> {
     const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey
    });
    const request = {
      loginKey,
      userId,
      pin
    };
    return this.http.post(
      `${ApiConfig.baseUrl}/auth/login`,
      request,
      {
        headers
      }
    );
  }
  postVerifyToken(token: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey
    });

    return this.http.post(
      `${ApiConfig.baseUrl}/auth/verify-token?token=${encodeURIComponent(token)}`,
      null,
      { headers }
    );
  }
  postManualLogout(key: string): Observable<any> {
    const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey
    });

    return this.http.post(
      `${ApiConfig.baseUrl}/auth/manual-logout?key=${encodeURIComponent(key)}`,
      null,
      { headers }
    );
  }
  postLogout(userSession: string): Observable<any> {
     const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

   return this.http.post(
      `${ApiConfig.baseUrl}/auth/logout`,
      null,
      { headers }
    );
  }
    postHelp(userSession: string): Observable<any> {
     const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey,
      'Authorization': `Bearer ${userSession}`
    });

   return this.http.post(
      `${ApiConfig.baseUrl}/auth/help`,
      null,
      { headers }
    );
  }
 getSecurityQuestionsAndAnswers(userId: string, requestType: string): Observable<any> {
  const headers = new HttpHeaders({
    'X-Api-Key': ApiConfig.apiKey
  });

  return this.http.get(
    `${ApiConfig.baseUrl}/auth/security-questions-and-answers`,
    {
      headers,
      params: {
        userId,
        requestType: requestType
      }
    }
  );
}
postIdentityNumber(userId: string, identityNumber: string): Observable<any> {
     const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey
    });
    const request = {
      userId,
      identityNumber
    };
    return this.http.post(
      `${ApiConfig.baseUrl}/auth/verify-identity-number`,
      request,
      {
        headers
      }
    );
  }
  postSecurityAnswer(userId: string, questionId: string, answer: string): Observable<any> {
     const headers = new HttpHeaders({
      'X-Api-Key': ApiConfig.apiKey
    });
    const request = {
      userId,
      questionId,
      answer
    };
    return this.http.post(
      `${ApiConfig.baseUrl}/auth/verify-security-answer`,
      request,
      {
        headers
      }
    );
  }
}